import React from 'react';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';

interface Props {
  id?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  type?: string;
  width?: number;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputProps?: {
    startAdornment?: JSX.Element;
    endAdornment?: JSX.Element;
  };
}

const Wrapper = styled.div<{ width?: number }>`
  width: ${props => props.width + 'px' || '200px'};
`;

const MyTextField: React.FunctionComponent<Props> = props => {
  return (
    <Wrapper {...props}>
      <TextField
        id={props.id || 'id'}
        label={props.label}
        placeholder={props.placeholder || ''}
        margin="normal"
        type={props.type ? props.type : 'text'}
        variant="outlined"
        value={props.value}
        onChange={props.onChange}
        InputProps={props.inputProps}
        fullWidth={true}
      />
    </Wrapper>
  );
};

export default MyTextField;
